import axios from 'axios';
import React from 'react';
import { useDashboardPermissions } from '@components/utils/DashboardPermissions';
import { Toasts } from '@fourthwall/components';
import { downloadBlob } from '@fourthwall/utils/dist/file';
import { useUnfulfilledOrdersCountQuery } from '../../../../../hooks/useUnfulfilledOrdersCountQuery';
import { FulfilledOrderIDsToast } from '../components/FulfilledOrderIDsToast/FulfilledOrderIDsToast';
import { useGetFulfillmentsCSVMutation } from '../queries/useGetFulfillmentsCSVMutation';
import { useUploadFulfillmentsCSVMutation } from '../queries/useUploadFulfillmentsCSVMutation';
export const useFulfillments = () => {
    const { hasPermission } = useDashboardPermissions();
    const { unfulfilledOrderCountQuery } = useUnfulfilledOrdersCountQuery(undefined, {
        enabled: hasPermission('contributions.fulfillments.view'),
    });
    const { getFulfillmentsCSVMutation } = useGetFulfillmentsCSVMutation();
    const { uploadFulfillmentsCSVMutation } = useUploadFulfillmentsCSVMutation({
        onSuccess: (data) => {
            const { fulfilledOrderIds, errors } = data;
            // fulfilled order ids
            if (fulfilledOrderIds.length) {
                Toasts.notify(React.createElement(FulfilledOrderIDsToast, { ids: fulfilledOrderIds }), {
                    type: 'success',
                    autoClose: false,
                });
            }
            // upload errors
            if (errors.length) {
                for (const error of errors) {
                    Toasts.notify(error, { type: 'error' });
                }
            }
            if (fulfilledOrderIds.length === 0 && errors.length === 0) {
                Toasts.notify('No new carrier codes and tracking numbers were provided in this CSV.', {
                    type: 'info',
                });
            }
        },
        onError: (error) => {
            const message = axios.isAxiosError(error)
                ? error.response?.data?.detail || 'Upload failed'
                : 'Upload failed';
            Toasts.notify(message, { type: 'error' });
        },
    });
    const downloadCSV = async () => {
        const data = await getFulfillmentsCSVMutation.mutateAsync([]);
        downloadBlob(data, 'orders.csv');
    };
    const uploadCSV = async (variables) => {
        await uploadFulfillmentsCSVMutation.mutateAsync([variables]);
    };
    return {
        ordersToManuallyFulfill: unfulfilledOrderCountQuery.data?.unfulfilledOrdersCount,
        isLoading: unfulfilledOrderCountQuery.isInitialLoading,
        isDownloading: getFulfillmentsCSVMutation.isLoading,
        isUploading: uploadFulfillmentsCSVMutation.isLoading,
        downloadCSV,
        uploadCSV: hasPermission('contributions.fulfillments.upload') ? uploadCSV : undefined,
    };
};
